import { ReadonlyURLSearchParams } from 'next/navigation'
import { ParsedUrlQuery } from 'querystring'

type QueryParams = ParsedUrlQuery | ReadonlyURLSearchParams

export const buildAuthQueryParams = (url: string, params: QueryParams): string => {
  const parts = url.split('?')
  const query = parts.length > 1 ? parts[1].split('&') : []

  const getParam = (key: string): string | undefined => {
    if (params instanceof URLSearchParams) {
      return params.get(key) ?? undefined
    }

    const value = params[key]

    return Array.isArray(value) ? value.join(',') : value
  }

  const features = getParam('features')
  const plan = getParam('plan')

  if (features) {
    query.unshift(`features=${features}`)
  }

  if (plan) {
    query.unshift(`plan=${plan}`)
  }

  return [
    parts[0],
    query.join('&'),
  ].join('?')
}
